import XHR from 'utils/_xhr'

export default class ProductService {
  static getProducts (options) {
    return XHR.post(window.main_theme_objects.ajax_url, {
      params: options
    })
      .then(res => {
        return JSON.parse(res.responseText)
      })
      .catch(err => {
        return err
      })
  }

  static addProductToCart (productId, quantity) {
    return XHR.post(window.main_theme_objects.ajax_url, {
      params: {
        action: 'add_product_to_cart',
        product_id: productId,
        quantity: quantity
      }
    })
      .then(res => {
        return JSON.parse(res.responseText)
      })
      .catch(err => {
        return err
      })
  }

  static addVariationToCart (productId, variationId, quantity, variations) {
    return XHR.post(window.main_theme_objects.ajax_url, {
      params: {
        action: 'add_variation_to_cart',
        product_id: productId,
        quantity: quantity,
        variant_id: variationId,
        variation: variations
      }
    })
      .then((res) => {
        return JSON.parse(res.responseText)
      })
      .catch((err) => {
        return err
      })
  }

  static removeAllFromMiniCart () {
    return XHR.post(window.main_theme_objects.ajax_url, {
      params: {
        action: 'remove_all_from_mini_cart'
      }
    })
      .then((res) => {
        return JSON.parse(res.responseText)
      })
      .catch((err) => {
        return err
      })
  }

  static removeProductFromMiniCart (cart_item_key) {
    return XHR.post(window.main_theme_objects.ajax_url, {
      params: {
        action: 'remove_product_from_mini_cart',
        cart_item_key: cart_item_key
      }
    })
      .then((res) => {
        return JSON.parse(res.responseText)
      })
      .catch((err) => {
        return err
      })
  }

  static removeAllFromCart () {
    return XHR.post(window.main_theme_objects.ajax_url, {
      params: {
        action: 'remove_all_from_cart'
      }
    })
      .then((res) => {
        return JSON.parse(res.responseText)
      })
      .catch((err) => {
        return err
      })
  }

  static removeProductFromCart (cart_item_key) {
    return XHR.post(window.main_theme_objects.ajax_url, {
      params: {
        action: 'remove_product_from_cart',
        cart_item_key: cart_item_key
      }
    })
      .then((res) => {
        return JSON.parse(res.responseText)
      })
      .catch((err) => {
        return err
      })
  }
}
